import * as React from 'react';
import Spin from 'antd/lib/spin';
import Select from 'antd/lib/select';
import { CommonProps } from './common.intefaces';
import { KeyLabel } from 'src/Library/Types';
import { fetchAllTeams } from 'src/api/teams';
import { isValidArray } from 'src/Library/Helper';

interface IProps extends CommonProps {
  apiOptions?: TeamApiParams;
  isStakeholder?: boolean;
}
interface TeamApiParams {
}

const TeamSelect = (props: IProps) => {

  const {
    mode,
    style,
    value,
    onChange,
    disabled,
    className,
    apiOptions,
    placeholder,
    isStakeholder,
  } = props;

  const [teams, setTeams] = React.useState<KeyLabel[]>([]);
  const [searching, setSearching] = React.useState<boolean>(false);

  React.useEffect(() => {
    getTeams();
  }, []);

  function getKeyLabelFromArray(inputArray): KeyLabel[] {
    if (!isValidArray(inputArray)) return [];
    return inputArray.map(item => ({
      key: item.id,
      label: item.name,
    }));
  }

  const getTeams = async () => {
    setSearching(true);
    if (isStakeholder){
      //if it's a stakeholder org, show only shared teams from shipper org
      // only implemented for Customer stakeholder for now
      const response = await fetchAllTeams({ fetchStakeholderTeams: true })
      setTeams(getKeyLabelFromArray(response?.data));
    } else {
      const response = await fetchAllTeams({ adminRestriction: true });
      const organisationId = window.localStorage.getItem('organisationId');
      // filter teams to show only those teams belonging to the current organisation
      // since parent orgs can see all shared teams
      const filteredTeams = response?.data.filter(team => team.organisation_id === organisationId);
      setTeams(getKeyLabelFromArray(filteredTeams));
    }
    setSearching(false);
  };

  const dropdownRender = (menu) => {
    if (searching) {
      return <Spin
        style={{
          marginLeft: '45%',
          marginTop: '20%',
        }}
      />;
    }
    return menu;
  };

  const renderTeamOptions = () => {
    return teams?.map(({ key, label }: KeyLabel) => (
      <Select.Option
        key={key}
        value={key}
      >
        {label}
      </Select.Option>)) || [];
  };
  return <Select
    style={{
      ...(style || {}),
    }}
    allowClear
    showSearch
    labelInValue
    value={value === null ? undefined : value}
    onChange={onChange}
    disabled={disabled}
    className={className}
    mode={mode || 'default'}
    filterOption={(inputValue, option) => {
      if (!inputValue) return true;
      const optionval = String(option.props?.children)?.trim().toLowerCase();
      return optionval.includes(inputValue.trim().toLowerCase());
    }}
    dropdownRender={dropdownRender}
    placeholder={placeholder || 'Select Team'}
    getPopupContainer={(trigger: any) => trigger.parentNode}
  >
    {renderTeamOptions()}
  </Select>;
};

export default TeamSelect;
